import { __awaiter, __generator } from "tslib";
import { fetchPricesGetByIds } from './http/fetch-prices-by-ids.get';
export var fetchGroupPrice = function (groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var prices;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, fetchPricesGetByIds([groupId], "g" /* Group */)];
            case 1:
                prices = _d.sent();
                if (!prices) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, ((_a = prices) === null || _a === void 0 ? void 0 : _a[0]) || ((_c = (_b = prices.search_phrase_suggestions) === null || _b === void 0 ? void 0 : _b.c_prices) === null || _c === void 0 ? void 0 : _c[0])];
        }
    });
}); };
